import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";

import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import httpClient from "api/httpClient";

function ResetPassword() {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  const validate = () => {
    if (!newPassword || newPassword.trim().length < 6)
      return "Password must be at least 6 characters.";
    if (newPassword !== confirm) return "Passwords do not match.";
    return "";
  };

  const handleSubmit = async () => {
    const msg = validate();
    if (msg) {
      setErrorMessage(msg);
      openErrorSB();
      return;
    }

    setLoading(true);
    try {
      await httpClient.post("/api/auth/reset-password", { newPassword });

      // update local auth flag so app stops forcing reset page
      const saved = localStorage.getItem("auth");
      if (saved) {
        const parsed = JSON.parse(saved);
        localStorage.setItem("auth", JSON.stringify({ ...parsed, passwordResetRequired: false }));
      }

      navigate("/dashboard", { replace: true });
    } catch (err) {
      setErrorMessage(err?.response?.data?.message || err.message || "Failed to reset password");
      openErrorSB();
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox p={3} textAlign="center">
          <MDTypography variant="h4">Reset Password</MDTypography>
          <MDTypography variant="button" color="text">
            You must reset your password to continue.
          </MDTypography>
        </MDBox>

        <MDBox px={3} pb={3}>
          <MDBox mb={2}>
            <MDInput
              type="password"
              label="New Password"
              fullWidth
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </MDBox>

          <MDBox mb={2}>
            <MDInput
              type="password"
              label="Confirm Password"
              fullWidth
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </MDBox>

          <MDButton
            variant="gradient"
            color="info"
            fullWidth
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="white" /> : "Save Password"}
          </MDButton>
        </MDBox>
      </Card>

      <MDSnackbar
        color="error"
        icon="warning"
        title="Error"
        content={errorMessage}
        dateTime=""
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </BasicLayout>
  );
}

export default ResetPassword;
